
import TableList from "@components/templates/tablelist";
import { HttpMinCostList, HttpDelMinCost, HttpExportMinCosts } from "@/service/fedex";
import { mapGetters } from "vuex";
// import mixin from "../mixin";
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            // Tabs: { show: true },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpMinCostList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'fedexUpdateMincharge',
                        params: { type: "add" },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'fedexUpdateMincharge',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "query":
                    var url = this.$router.resolve({
                        name: "fedexUpdateMincharge",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "delete":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { id: params },
                        title: this.$t('global.common.delete',{defaultValue:'删除'}),
                        desc: this.$t('fbb.localemanage.confirm_delete',{defaultValue:'删除后不可恢复，是否确认删除？'}),
                        ajaxRequest: HttpDelMinCost
                    };
                    break;
                case 'export':
                    this.handleWebfs(HttpExportMinCosts, this.formData, 'download')
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row
            return [{
                label: this.$t('fbb.alloment.query_detail',{defaultValue:'查看详情'}),
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: this.$t('global.common.edit',{defaultValue:'编辑'}),
                show: true,
                params: id,
                operate: 'edit'
            }, {
                label: this.$t('global.common.delete',{defaultValue:'删除'}),
                show: true,
                params: id,
                operate: 'delete'
            }]
        }
    },
    computed: {
        ...mapGetters('dictionary', ['getCarrierServiceAllList']),
        ToolsData() {
            return [
                {
                    name: this.$t('erp.product.new_add',{defaultValue:'添加'}),
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: this.$t('fbb.alloment.muti_export',{defaultValue:'批量导出'}),
                    operate: "export",
                    theme: "success"
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.fedexcost.account',{defaultValue:'账户'}),
                    tag: 'vInput',
                    key: 'EQ_account',
                    show: true,
                },
                {
                    // label: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                    label: "承运商服务",
                    tag: 'Select',
                    key: 'EQ_carrierServiceCode',
                    show: true,
                    options: this.getCarrierServiceAllList.map(item=>{
                        return {
                            value: item.attach.carrierServiceCode,
                            label:item.label
                        }
                    }),
                    props: {
                        filterable: true,
                    }
                },
            ]
        },
        columns() {
            return [{
                title: this.$t('global.common.actions',{defaultValue:'操作'}),
                maxWidth: 90,
                render: this.getOperateNodes
            }, {
                title: this.$t('fbb.fedexcost.account',{defaultValue:'账户'}),
                key: 'account',
            },
            {
                // title: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                title: "承运商服务",
                key:'carrierServiceCode'
                // render: (h,{row}) =>{
                //     return <div>{row.carrierCode} ({row.carrierServiceCode})</div>
                // }
            },
            {
                title: this.$t('fbb.account.cusdisacountrate_weight_min',{defaultValue:'重量区间最小值'})+'(lbs)',
                key: 'weightRangeMin',
            },
            {
                title: this.$t('fbb.account.cusdisacountrate_weight_max',{defaultValue:'重量区间最大值'})+'(lbs)',
                key: 'weightRangeMax',
            },
            {
                title: this.$t('fbb.customerMinimumCharges.minCost',{defaultValue:'最低收费'})+'(usd)',
                key: 'minCost',
            },
            ];
        },

    },

};
